import { storeGodownResult } from "../../godown_search/data/actions"

/**
 * Handle segment ledger selection
 * @param {Object} e - event object
 * @param {Object} values - form values
 * @param {Function} setFieldValue - function to set field value
 * @param {String} fieldName - field name
 * @param {Object} obj - object containing ledger name and code
 * @param {Function} dispatch - function to dispatch action
 */
export const handleSegmentLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (obj) {
        const { ledgerName, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('seg_ledger_cd', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('seg_ledger_cd', '')
    }
}

/**
 * Handle segment ledger on blur event
 * If the value is empty, set the segment ledger code field to empty string
 * @param {Object} e - event object
 * @param {Object} values - form values
 * @param {Function} setFieldValue - function to set field value
 * @param {String} fieldName - field name
 * @param {Object} obj - object containing ledger name and code
 * @param {Function} dispatch - function to dispatch action
 */
export const handleSegmentLedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (!e.target.value) {
        setFieldValue('seg_ledger_cd', '')
    }
}

/**
 * Handle STPI segment ledger selection
 * @param {Object} e - event object
 * @param {Object} values - form values
 * @param {Function} setFieldValue - function to set field value
 * @param {String} fieldName - field name
 * @param {Object} obj - object containing ledger name and code
 * @param {Function} dispatch - function to dispatch action
 */
export const handleStpiSegmentLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (obj) {
        const { ledgerName, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('stpi_seg_ledger_cd', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('stpi_seg_ledger_cd', '')
    }
}

/**
 * Handle STPI segment ledger on blur event
 * If the value is empty, set the STPI segment ledger code field to empty string
 * @param {Object} e - event object
 * @param {Object} values - form values
 * @param {Function} setFieldValue - function to set field value
 * @param {String} fieldName - field name
 * @param {Object} obj - object containing ledger name and code
 * @param {Function} dispatch - function to dispatch action
 */
export const handleStpiSegmentLedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (!e.target.value) {
        setFieldValue('stpi_seg_ledger_cd', '')
    }
}

/**
 * Handle WI Sales Ledger selection
 */
export const handleWiSalesLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (obj) {
        const { ledgerName, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('wi_sl_pur_ledger_cd', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('wi_sl_pur_ledger_cd', '')
    }
}

export const handleWiSalesLedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (!e.target.value) {
        setFieldValue('wi_sl_pur_ledger_cd', '')
    }
}

/**
 * Handle CI Sales Ledger selection
 */
export const handleCiSalesLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (obj) {
        const { ledgerName, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('ci_sl_pur_ledger_cd', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('ci_sl_pur_ledger_cd', '')
    }
}

export const handleCiSalesLedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (!e.target.value) {
        setFieldValue('ci_sl_pur_ledger_cd', '')
    }
}

/**
 * Handle PP Purchase Ledger selection
 */
export const handlePpPurchaseLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (obj) {
        const { ledgerName, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('pp_sl_pur_ledger_cd', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('pp_sl_pur_ledger_cd', '')
    }
}

export const handlePpPurchaseLedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (!e.target.value) {
        setFieldValue('pp_sl_pur_ledger_cd', '')
    }
}

/**
 * Handle EW Control Ledger selection
 */
export const handleEwControlLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (obj) {
        const { ledgerName, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('ew_sl_pur_ledger_cd', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('ew_sl_pur_ledger_cd', '')
    }
}

export const handleEwControlLedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (!e.target.value) {
        setFieldValue('ew_sl_pur_ledger_cd', '')
    }
}

/**
 * Handle EWC Control Ledger selection
 */
export const handleEwcControlLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (obj) {
        const { ledgerName, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('ewc_sl_pur_ledger_cd', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('ewc_sl_pur_ledger_cd', '')
    }
}

export const handleEwcControlLedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (!e.target.value) {
        setFieldValue('ewc_sl_pur_ledger_cd', '')
    }
}

/**
 * Handle CCP Control Ledger selection
 */
export const handleCcpControlLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (obj) {
        const { ledgerName, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('ccp_sl_pur_ledger_cd', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('ccp_sl_pur_ledger_cd', '')
    }
}

export const handleCcpControlLedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (!e.target.value) {
        setFieldValue('ccp_sl_pur_ledger_cd', '')
    }
}

/**
 * Handle CCPC Control Ledger selection
 */
export const handleCcpcControlLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (obj) {
        const { ledgerName, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('ccpc_sl_pur_ledger_cd', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('ccpc_sl_pur_ledger_cd', '')
    }
}

export const handleCcpcControlLedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (!e.target.value) {
        setFieldValue('ccpc_sl_pur_ledger_cd', '')
    }
}

export const handleGodownSelection = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (obj) {
        const { name } = obj
        setFieldValue(fieldName, name)
    }
}

/**
 * Set godown object on edit
 * @param {Object} values - form values
 * @param {Function} dispatch - function to dispatch action
 */
export const setGodownObjOnEdit = (values, dispatch) => {
    const godownFields = [
        'godown',
        'ci_godown',
        'stpi_godown',
        'pp_godown',
        'wi_godown',
        'wi_bndp_godown',
        'ci_godown',
        'stpi_godown',
        'pp_godown',
        'wi_godown',
        'wi_bndp_godown',
    ];

    godownFields.forEach((key) => {
        const value = values[key];
        if (value !== null && value !== undefined && value !== '') {
            dispatch(storeGodownResult([{
                key: value,
                value: value,
                text: value,
                title: value,
                godownName: value,
            }], key));
        } else {
            dispatch(storeGodownResult([], key));
        }
    });
}